import {DashboardMenuOption} from 'components/dashboard-menu/component'
import { PanelBarOption } from 'components/panel-bar/types'
import React from 'react'
import {BlastsComponent} from './component'
import { allSections } from './constants'

export const routes = allSections.map((item: PanelBarOption) => (
  {
    action: () => <BlastsComponent selectedItem={item} />,
    path: DashboardMenuOption.blasts + (item.route.length === 0 ? '' : '/' + item.route),
  }
));
